export default __webpack_public_path__ + "293f937ce8a6ca069617aa398986438d.png";